// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Box from "../../resources/layout-and-structure/Box.res.js";
import * as Env from "../../core/Env.res.js";
import * as I18n from "../../primitives/I18n.res.js";
import * as Json from "../../primitives/Json.res.js";
import * as Page from "../../resources/layout-and-structure/Page.res.js";
import * as Badge from "../../resources/feedback-indicators/Badge.res.js";
import * as Stack from "../../resources/layout-and-structure/Stack.res.js";
import * as React from "react";
import * as Button from "../../resources/actions/Button.res.js";
import * as Future from "rescript-future/src/Future.res.js";
import * as Request from "../../core/Request.res.js";
import * as Tooltip from "../../resources/overlays/Tooltip.res.js";
import * as SearchBar from "../../resources/selection-and-input/SearchBar.res.js";
import * as TableView from "../../resources/tables/TableView.res.js";
import * as TextStyle from "../../resources/typography/TextStyle.res.js";
import * as AuthRoutes from "../Auth/AuthRoutes.res.js";
import * as BarControl from "../../resources/layout-and-structure/BarControl.res.js";
import * as EmptyState from "../../resources/layout-and-structure/EmptyState.res.js";
import * as Navigation from "../../primitives/Navigation.res.js";
import * as AsyncResult from "../../primitives/AsyncResult.res.js";
import * as Auth__Types from "../../bundles/Auth/Auth__Types.res.js";
import * as Stdlib_Math from "@rescript/runtime/lib/es6/Stdlib_Math.js";
import * as TooltipIcon from "../../resources/overlays/TooltipIcon.res.js";
import * as Illustration from "../../resources/images-and-icons/Illustration.res.js";
import * as Stdlib_Array from "@rescript/runtime/lib/es6/Stdlib_Array.js";
import * as Stdlib_Option from "@rescript/runtime/lib/es6/Stdlib_Option.js";
import * as LegacyPagination from "../../resources/navigation/LegacyPagination.res.js";
import * as Primitive_option from "@rescript/runtime/lib/es6/Primitive_option.js";
import * as JsxRuntime from "react/jsx-runtime";
import * as Belt_HashMapString from "@rescript/runtime/lib/es6/Belt_HashMapString.js";

function decodeResultItem(jsonUser) {
  let userDict = Json.decodeDict(jsonUser);
  let userScopeDict = Json.flatDecodeDictFieldDict(userDict, "scope");
  let match = Json.flatDecodeDictFieldString(userDict, "id");
  let match$1 = Json.flatDecodeDictFieldString(userDict, "organizationName");
  let match$2 = Json.flatDecodeDictFieldString(userDict, "username");
  let match$3 = Json.flatDecodeDictFieldString(userDict, "name");
  let match$4 = Stdlib_Option.map(Json.flatDecodeDictFieldArray(userScopeDict, "shopIds"), shopIds => Stdlib_Array.filterMap(shopIds, Json.decodeString));
  if (match !== undefined && match$1 !== undefined && match$2 !== undefined && match$3 !== undefined && match$4 !== undefined) {
    return {
      id: match,
      organizationName: match$1,
      username: match$2,
      name: match$3,
      shopsIds: match$4
    };
  }
}

function decodeResult(json) {
  let resultItems = Json.decodeArray(json);
  if (resultItems !== undefined) {
    return Stdlib_Array.filterMap(resultItems, decodeResultItem);
  } else {
    return [];
  }
}

let endpoint = Env.gatewayUrl() + "/admin/users";

function make() {
  return Future.mapOk(Request.make(endpoint, "GET", undefined, undefined, undefined), undefined, decodeResult);
}

let QueryAllUsersRequest = {
  decodeResultItem: decodeResultItem,
  decodeResult: decodeResult,
  endpoint: endpoint,
  make: make
};

function decodeResultItem$1(json) {
  let dict = Json.decodeDict(json);
  let match = Json.flatDecodeDictFieldString(dict, "id");
  let match$1 = Json.flatDecodeDictFieldString(dict, "name");
  let match$2 = Json.flatDecodeDictFieldString(dict, "type");
  if (match !== undefined && match$1 !== undefined) {
    return {
      id: match,
      name: match$1,
      type_: match$2
    };
  }
}

function decodeResult$1(json) {
  let resultItems = Json.decodeArray(json);
  if (resultItems !== undefined) {
    return Stdlib_Array.filterMap(resultItems, decodeResultItem$1);
  } else {
    return [];
  }
}

let endpoint$1 = Env.gatewayUrl() + "/admin/shops";

function make$1() {
  return Future.mapOk(Request.make(endpoint$1, "GET", undefined, undefined, undefined), undefined, decodeResult$1);
}

let QueryAllShopsRequest = {
  decodeResultItem: decodeResultItem$1,
  decodeResult: decodeResult$1,
  endpoint: endpoint$1,
  make: make$1
};

function mergeQueryAllUsersResultWithQueryAllShopsResult(param) {
  let queryAllShops = param[1];
  let queryAllUsers = param[0];
  if (queryAllUsers.TAG !== "Ok") {
    return {
      TAG: "Error",
      _0: undefined
    };
  }
  let queryAllUsers$1 = queryAllUsers._0;
  if (queryAllShops.TAG !== "Ok") {
    return {
      TAG: "Error",
      _0: undefined
    };
  }
  let queryAllShops$1 = queryAllShops._0;
  if (queryAllUsers$1.length === 0 || queryAllShops$1.length === 0) {
    return {
      TAG: "Error",
      _0: undefined
    };
  }
  let hashMapShops = Belt_HashMapString.fromArray(queryAllShops$1.map(param => [
    param.id,
    {
      name: param.name,
      type_: param.type_
    }
  ]));
  let items = queryAllUsers$1.map(user => ({
    id: user.id,
    organizationName: user.organizationName,
    username: user.username,
    name: user.name,
    shops: Stdlib_Array.filterMap(user.shopsIds, id => Belt_HashMapString.get(hashMapShops, id))
  }));
  return {
    TAG: "Ok",
    _0: items
  };
}

function make$2() {
  let futures = Future.all2([
    make(),
    make$1()
  ]);
  return Future.map(futures, undefined, mergeQueryAllUsersResultWithQueryAllShopsResult);
}

let QueryAllUsersWithAssociatedShopsRequest = {
  mergeQueryAllUsersResultWithQueryAllShopsResult: mergeQueryAllUsersResultWithQueryAllShopsResult,
  make: make$2
};

function keyExtractor(row) {
  return row.id;
}

function sanitize(string) {
  return string.toLowerCase().normalize("NFD").replace(/[\u0300-\u036f]/g, "").replace(/[^a-zA-Z0-9 ]/g, "");
}

function matchShopsNames(shopsNames, query) {
  return shopsNames.map(sanitize).some(shopName => shopName.includes(sanitize(query)));
}

function match(row, query) {
  if (query === "" || row.id === query || matchShopsNames(row.shops.map(shop => shop.name), query) || sanitize(row.email).includes(sanitize(query)) || sanitize(row.organizationName).includes(sanitize(query))) {
    return true;
  } else {
    return sanitize(row.userName).includes(sanitize(query));
  }
}

function fromQueryItem(queryItem) {
  return {
    id: queryItem.id,
    organizationName: queryItem.organizationName,
    userName: queryItem.name,
    email: queryItem.username,
    shops: queryItem.shops.map(shop => ({
      name: shop.name,
      kind: Stdlib_Option.getOr(Stdlib_Option.flatMap(shop.type_, Auth__Types.ShopKind.fromString), "INDEPENDENT")
    }))
  };
}

let TableRow = {
  keyExtractor: keyExtractor,
  sanitize: sanitize,
  matchShopsNames: matchShopsNames,
  match: match,
  fromQueryItem: fromQueryItem
};

function totalPages(rows) {
  return Stdlib_Math.Int.ceil(rows.length / 10);
}

function search(rows, searchQuery) {
  return rows.filter(row => match(row, searchQuery));
}

function paginate(rows, currentPage) {
  return rows.slice((currentPage - 1 | 0) * 10 | 0, currentPage * 10 | 0);
}

function fromQueryAllUsers(queryAllUsers) {
  return queryAllUsers.map(fromQueryItem);
}

let TableRows = {
  rowsPerPage: 10,
  totalPages: totalPages,
  search: search,
  paginate: paginate,
  fromQueryAllUsers: fromQueryAllUsers
};

function AdminImpersonationPage$TableItemShopsCell(props) {
  let shopsNames = props.shopsNames;
  let ref = React.useRef(null);
  let len = shopsNames.length;
  let formattedText = len !== 1 ? (
      len !== 0 ? I18n.template(I18n.t("{{count}} shops"), {
          count: shopsNames.length
        }, undefined) : I18n.t("No shops associated")
    ) : shopsNames[0];
  let len$1 = shopsNames.length;
  let tooltipContent = len$1 !== 1 && len$1 !== 0 ? shopsNames.map(shopName => JsxRuntime.jsxs(React.Fragment, {
      children: [
        JsxRuntime.jsx(Tooltip.Span.make, {
          text: `•  ` + shopName
        }),
        JsxRuntime.jsx(Tooltip.Gap.make, {
          space: "xxsmall"
        })
      ]
    }, shopName)) : undefined;
  if (tooltipContent !== undefined) {
    return JsxRuntime.jsxs("div", {
      children: [
        JsxRuntime.jsx(TextStyle.make, {
          children: formattedText,
          variation: "subdued"
        }),
        JsxRuntime.jsx(TooltipIcon.make, {
          children: tooltipContent,
          variation: "info",
          altTriggerRef: ref
        })
      ],
      ref: Primitive_option.some(ref),
      style: {
        display: "flex",
        alignItems: "center",
        gridGap: "6px"
      }
    });
  } else {
    return JsxRuntime.jsx(TextStyle.make, {
      children: formattedText
    });
  }
}

let TableItemShopsCell = {
  make: AdminImpersonationPage$TableItemShopsCell
};

function tableColumns(handleImpersonate) {
  return [
    {
      key: "name",
      name: I18n.t("Name / organization"),
      layout: {
        minWidth: {
          NAME: "px",
          VAL: 200
        },
        sticky: true
      },
      render: param => {
        let match = param.data;
        return JsxRuntime.jsx(Box.make, {
          children: JsxRuntime.jsxs(Stack.make, {
            children: [
              JsxRuntime.jsx(TextStyle.make, {
                children: match.userName,
                weight: "strong"
              }),
              JsxRuntime.jsx(TextStyle.make, {
                children: match.organizationName,
                variation: "normal",
                size: "xxsmall"
              })
            ],
            space: "xxsmall"
          }),
          spaceY: "xxsmall"
        });
      }
    },
    {
      key: "email",
      name: I18n.t("Email address"),
      layout: {
        minWidth: {
          NAME: "px",
          VAL: 320
        }
      },
      render: param => JsxRuntime.jsx(TextStyle.make, {
        children: param.data.email
      })
    },
    {
      key: "shops",
      name: I18n.t("Shop(s)"),
      layout: {
        minWidth: {
          NAME: "px",
          VAL: 250
        },
        margin: "large"
      },
      render: param => {
        let shopsNames = param.data.shops.map(shop => shop.name);
        return JsxRuntime.jsx(AdminImpersonationPage$TableItemShopsCell, {
          shopsNames: shopsNames
        });
      }
    },
    {
      key: "kind",
      name: I18n.t("Kind"),
      layout: {
        minWidth: {
          NAME: "px",
          VAL: 160
        }
      },
      render: param => {
        let shopKinds = param.data.shops.map(shop => shop.kind);
        let sharedKind = Stdlib_Option.flatMap(shopKinds[0], firstKind => {
          if (shopKinds.every(kind => kind === firstKind)) {
            return firstKind;
          }
        });
        if (sharedKind !== undefined) {
          return JsxRuntime.jsx(Auth__Types.ShopKind.Badge.make, {
            value: sharedKind
          });
        } else {
          return JsxRuntime.jsx(TextStyle.make, {
            children: I18n.t("Differing"),
            variation: "subdued",
            size: "xsmall"
          });
        }
      }
    },
    {
      key: "action",
      layout: {
        minWidth: {
          NAME: "px",
          VAL: 110
        },
        alignX: "flexEnd"
      },
      render: param => {
        let id = param.data.id;
        return JsxRuntime.jsx(Button.make, {
          label: I18n.t("Impersonate"),
          size: "small",
          onPress: () => handleImpersonate(id)
        });
      }
    }
  ];
}

let initialState_asyncResult = AsyncResult.notAsked();

let initialState = {
  searchQuery: "",
  currentPage: 1,
  asyncResult: initialState_asyncResult
};

function make$3(prevState, action) {
  switch (action.TAG) {
    case "SearchQueryChanged" :
      return {
        searchQuery: action._0,
        currentPage: 1,
        asyncResult: prevState.asyncResult
      };
    case "AsyncResultGet" :
      return {
        searchQuery: prevState.searchQuery,
        currentPage: 1,
        asyncResult: action._0
      };
    case "Paginated" :
      let totalPages = action._1;
      let match = prevState.currentPage;
      let tmp;
      switch (action._0) {
        case "First" :
          tmp = 1;
          break;
        case "Prev" :
          tmp = match !== 1 ? prevState.currentPage - 1 | 0 : 1;
          break;
        case "Next" :
          tmp = match >= totalPages ? match : prevState.currentPage + 1 | 0;
          break;
        case "Last" :
          tmp = totalPages;
          break;
      }
      return {
        searchQuery: prevState.searchQuery,
        currentPage: tmp,
        asyncResult: prevState.asyncResult
      };
  }
}

let Reducer = {
  initialState: initialState,
  make: make$3
};

function AdminImpersonationPage(props) {
  let mounted = React.useRef(false);
  let match = React.useReducer(make$3, initialState);
  let state = match[0];
  let currentPage = state.currentPage;
  let searchQuery = state.searchQuery;
  let dispatch = match[1];
  let handleImpersonate = userId => Navigation.openNewTabRoute(AuthRoutes.impersonationRoute(userId));
  React.useEffect(() => {
    if (mounted.current) {
      return;
    }
    let request = make$2();
    dispatch({
      TAG: "AsyncResultGet",
      _0: AsyncResult.loading()
    });
    Future.get(request, result => dispatch({
      TAG: "AsyncResultGet",
      _0: AsyncResult.done(result)
    }));
    return () => Future.cancel(request);
  }, []);
  React.useEffect(() => {
    mounted.current = true;
    return () => {
      mounted.current = false;
    };
  }, []);
  let columns = tableColumns(handleImpersonate);
  let tableRows = AsyncResult.mapOk(state.asyncResult, fromQueryAllUsers);
  let searchedTableRows = AsyncResult.mapOk(tableRows, rows => search(rows, searchQuery));
  let totalPages$1;
  if (typeof searchedTableRows !== "object") {
    totalPages$1 = 1;
  } else if (searchedTableRows.TAG === "Reloading") {
    let rows = searchedTableRows._0;
    totalPages$1 = rows.TAG === "Ok" ? totalPages(rows._0) : 1;
  } else {
    let rows$1 = searchedTableRows._0;
    totalPages$1 = rows$1.TAG === "Ok" ? totalPages(rows$1._0) : 1;
  }
  let searchedAndPaginatedTableRows = AsyncResult.mapOk(searchedTableRows, rows => paginate(rows, currentPage));
  let onRequestSearch = queryString => dispatch({
    TAG: "SearchQueryChanged",
    _0: queryString
  });
  let onRequestPaginate = paginateAction => dispatch({
    TAG: "Paginated",
    _0: paginateAction,
    _1: totalPages$1
  });
  let match$1 = state.asyncResult;
  let placeholderEmptyState;
  if (typeof searchedAndPaginatedTableRows !== "object" || searchedAndPaginatedTableRows.TAG !== "Done") {
    placeholderEmptyState = EmptyState.error;
  } else {
    let match$2 = searchedAndPaginatedTableRows._0;
    if (match$2.TAG === "Ok" && match$2._0.length === 0 && typeof match$1 === "object" && match$1.TAG === "Done") {
      let rows$2 = match$1._0;
      placeholderEmptyState = rows$2.TAG === "Ok" && rows$2._0.length !== 0 ? JsxRuntime.jsx(EmptyState.make, {
          illustration: Illustration.noResultFound,
          title: I18n.t("No result were found."),
          text: I18n.t("Try again with another keyword or:"),
          children: JsxRuntime.jsx(Button.make, {
            label: I18n.t("Clear search query"),
            onPress: () => dispatch({
              TAG: "SearchQueryChanged",
              _0: ""
            })
          })
        }) : EmptyState.error;
    } else {
      placeholderEmptyState = EmptyState.error;
    }
  }
  let searchBar = JsxRuntime.jsx(Box.make, {
    children: JsxRuntime.jsx(SearchBar.make, {
      placeholder: I18n.t("Search an user"),
      value: searchQuery,
      onChange: onRequestSearch
    }),
    spaceX: "large",
    spaceBottom: "xmedium"
  });
  return JsxRuntime.jsxs(Page.make, {
    children: [
      JsxRuntime.jsx(BarControl.make, {}),
      JsxRuntime.jsx(TableView.make, {
        data: searchedAndPaginatedTableRows,
        columns: columns,
        keyExtractor: keyExtractor,
        placeholderEmptyState: placeholderEmptyState,
        searchBar: searchBar
      }),
      JsxRuntime.jsx(LegacyPagination.make, {
        currentPage: currentPage,
        totalPages: totalPages$1,
        onRequestPaginate: onRequestPaginate
      })
    ],
    variation: "compact",
    title: I18n.t("Impersonation"),
    subtitle: I18n.t("List of users"),
    renderTitleEnd: () => JsxRuntime.jsx(Badge.make, {
      children: I18n.t("Support"),
      variation: "primary"
    })
  });
}

let make$4 = React.memo(AdminImpersonationPage);

export {
  QueryAllUsersRequest,
  QueryAllShopsRequest,
  QueryAllUsersWithAssociatedShopsRequest,
  TableRow,
  TableRows,
  TableItemShopsCell,
  tableColumns,
  Reducer,
  make$4 as make,
}
/* endpoint Not a pure module */
